import React, { useState } from "react";
import { Modal, Box, Typography, Button, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CreditCardIcon from "@material-ui/icons/CreditCard";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800, // Ajusta el ancho según sea necesario
  bgcolor: "#323940",
  color: "#CCCCCC",
  boxShadow: 24,
  borderRadius: "8px",
  p: 2,
  display: "flex",
  flexDirection: "column",
  position: "relative",
  overflowY: "auto", // Habilita el scroll vertical
  maxHeight: "90vh", // Limita la altura del contenedor
  padding: "16px", // Asegura un espacio adecuado
  marginbottom:"15px",
  //SCROLL
  "&::-webkit-scrollbar": {
    width: "6px", // Ancho del scroll
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#CCCCCC", // Color del scroll
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#6c6f73", // Color al pasar el mouse
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#2a333d", // Fondo del track del scroll
  },
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginbottom: "1px",
  color: "#CCCCCC",
};
const titleStyle = {
  display: "flex",
  alignItems: "center", // Alinear el ícono y el texto
  color: "#CCCCCC",
};
const ModalCardAdmin = ({
  open,
  onClose,
  children,
  titulo,
  props,
  tarjeta,
  dataEtapa,
  data,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box sx={headerStyle}>
          <Box sx={titleStyle}>
            <CreditCardIcon
              sx={{ marginRight: 1 }}
              style={{ color: "#CCCCCC" }}
            />
            <Typography
              variant="h6"
              component="h2"
              style={{ color: "#CCCCCC" }}
            >
              {data?.titulo}
            </Typography>
          </Box>
          <IconButton
            aria-label="close"
            onClick={onClose}
            style={{ color: "#CCCCCC" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography
          variant="subtitle2"
          component="h3"
          style={{ color: "#CCCCCC" }}
        >
          En lista{" "}
          <span style={{ textDecoration: "underline" }}>
          {dataEtapa?.titulo}{" "}
          </span>
        </Typography>
        {children}
      </Box>
    </Modal>
  );
};

export default ModalCardAdmin;
